import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const VIEW_TYPES = [
  { value: "on_screen", label: "On Screen" },
  { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel" },
  { value: "excel_unformatted", label: "Excel(Unformatted)" },
  { value: "email", label: "Email" },
];

const ASSET_CLASSES = [
  { key: "mutual_fund", label: "Mutual Fund" },
  { key: "share_bond", label: "Share & Bond" },
];

const REPORT_TYPES = [
  { value: "summary", label: "Summary" },
  { value: "detail", label: "Detail" },
];

const inputBorderStyle = { borderRadius: "8px", border: `1px solid ${TEAL}` };

export default function CapitalGainUnrealized() {
  const [viewType, setViewType] = useState("excel_unformatted");
  const [assets, setAssets] = useState(() =>
    ASSET_CLASSES.reduce((acc, a) => ({ ...acc, [a.key]: true }), {})
  );
  const [reportType, setReportType] = useState("summary");
  const [investor, setInvestor] = useState("all");
  const [reportDate, setReportDate] = useState("2026-02-12");
  const [source, setSource] = useState("all");
  const [applying, setApplying] = useState(false);

  const toggleAsset = (key) => {
    setAssets((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
    // TODO: generate report based on filters
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Capital Gain Unrealized</h3>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/capital-gain-unrealized">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Capital Gain Unrealized</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          {/* View Type */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              View Type:
            </label>
            <div className="d-flex flex-wrap gap-3">
              {VIEW_TYPES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="viewType"
                    value={opt.value}
                    checked={viewType === opt.value}
                    onChange={() => setViewType(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Assets Class (checkboxes) */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Assets Class :
            </label>
            <div className="d-flex flex-wrap gap-3">
              {ASSET_CLASSES.map((a) => (
                <label key={a.key} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={assets[a.key]}
                    onChange={() => toggleAsset(a.key)}
                    style={{ accentColor: TEAL, width: 16, height: 16 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{a.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Report Type */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Report Type :
            </label>
            <div className="d-flex flex-wrap gap-3">
              {REPORT_TYPES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="reportType"
                    value={opt.value}
                    checked={reportType === opt.value}
                    onChange={() => setReportType(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Filter */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "12px" }}>
              Filter:
            </label>
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label small text-muted">Investor :</label>
                <select
                  className="form-select form-select-sm"
                  value={investor}
                  onChange={(e) => setInvestor(e.target.value)}
                  style={inputBorderStyle}
                >
                  <option value="all">All</option>
                  <option value="primary">Primary</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">Report as on Date:</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={reportDate}
                  onChange={(e) => setReportDate(e.target.value)}
                  style={inputBorderStyle}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">Source</label>
                <select
                  className="form-select form-select-sm"
                  value={source}
                  onChange={(e) => setSource(e.target.value)}
                  style={inputBorderStyle}
                >
                  <option value="all">All</option>
                </select>
              </div>
            </div>
          </div>

          {/* Apply */}
          <div className="d-flex justify-content-center pt-2">
            <button
              type="button"
              className="btn px-5 py-2"
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "15px",
              }}
              onClick={handleApply}
              disabled={applying}
            >
              {applying ? "Applying…" : "Apply"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
